import script from "./Markers.vue?vue&type=script&lang=ts"
export * from "./Markers.vue?vue&type=script&lang=ts"

export default script